var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.333,
    height: 4.667,
    viewBox: "0 0 9.333 4.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8f9bb3;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.666,9.333A.667.667,0,0,1,.154,8.24L3.138,4.659.262,1.085A.667.667,0,0,1,1.3.249l3.219,4a.667.667,0,0,1-.007.845l-3.333,4a.666.666,0,0,1-.513.24",
    transform: "translate(0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.667) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.666,9.333A.667.667,0,0,1,.154,8.24L3.138,4.659.262,1.085A.667.667,0,0,1,1.3.249l3.219,4a.667.667,0,0,1-.007.845l-3.333,4a.666.666,0,0,1-.513.24",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.d7a9d3e045626aa5feeeccae4d395d2c.svg";
export { ForwardRef as ReactComponent };